import React from 'react'

import { TbH2 } from 'react-icons/tb'

import { useIntl } from '@app/intl/Intl'
import { BlockButton } from '@app/lib/inputs/RichEditor/blocks/BlockButton'
import { TextElementType } from '@app/lib/inputs/RichEditor/types'

export const HeadingTwoButton = () => {
  const { formatMessage } = useIntl()

  return (
    <BlockButton
      format={TextElementType.HeadingTwo}
      icon={<TbH2 />}
      aria-label={formatMessage({ id: 'RichEditor.Element.HeadingTwo' })}
    />
  )
}
